// extracted by mini-css-extract-plugin
module.exports = {"content":"Vh","lookName":"Wh","shopTheLookContainer":"Xh","productContainer":"Yh","imageContainer":"Zh","mainImage":"_h"};